import Vue from 'vue';
import Router from 'vue-router';
import Intro from '@/components/Intro';
import FullQuiz from '@/components/FullQuiz';
import HighScores from '@/components/HighScores';
import Statistics from '@/components/Statistics';
import Solutions from '@/components/Solutions';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/oppgaver',
      name: 'Oppgaver',
      component: FullQuiz
    },
    {
      path: '/highscores',
      name: 'HighScores',
      component: HighScores
    },
    {
      path: '/highscores/novanet',
      name: 'HighScoresNovanet',
      component: HighScores,
      props: { isNovanetScores: true }
    },
    {
      path: '/statistics',
      name: 'Statistics',
      component: Statistics,
      props: { isNovanet: false }
    },
    {
      path: '/solutions',
      name: 'Fasit',
      component: Solutions
    },
    {
      path: '/statistics/novanet',
      name: 'StatisticsNovanet',
      component: Statistics,
      props: { isNovanet: true }
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js